module.exports = __webpack_public_path__ + "media/game_end_5.d403c34a.mp3";